<span class="fa-stack {{ faSize }}">
    <ng-content></ng-content>
</span>
